// extracted by mini-css-extract-plugin
export default {"home":"Home_home__XtFxB","outlet":"Home_outlet__Nita1"};